import React, { useState } from "react";
import style from "./style.module.css";
import { FaUser } from "react-icons/fa";
import UserProfilePopup from "../userProflePopup/UserProfilePopup";
import { useTenant } from "../../context/TenantContext";

const CommonHeader = ({ publicMode = false }) => {
  const { logo } = useTenant();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleUserClick = () => {
      setIsPopupOpen(!isPopupOpen);
    };
  return (
    <div className={style.mainContainer}>
      <div className={style.imageBox}>
        {" "}
        <img src={logo} alt="Logo" className={style.logoimage} />
      </div>
      {/* publicMode: used on the public creator-signup page where no one is
          logged in. Hiding the profile widget also prevents UserProfilePopup
          from calling the protected /profile API (which 401s when logged out). */}
      {!publicMode && (
        <div className={style.userIcon}>
          <FaUser
            onClick={handleUserClick}
            className={style.searchIconSize}
          />
          <UserProfilePopup
            isOpen={isPopupOpen}
            onClose={() => setIsPopupOpen(false)}
          />
        </div>
      )}
    </div>
  );
};

export default CommonHeader;
